










































































import _ from 'lodash';
import { Vozidlo } from '@/modules/kartoteka/vozidlo';
import { Partner } from '@/modules/kartoteka/partner';
import { Typ } from '@/modules/ciselnik/dilenske/typ';
import { LakDruh } from '@/modules/ciselnik/dilenske/lakDruh';
import { Pracovnik } from '@/modules/administrace/pracovnik';
import { NakladoveStredisko } from '@/modules/ciselnik/firemni/nakladoveStredisko';
import { showAlert } from '@/main/utils/notifications';
import { listFactory, ListLoadBehavior } from '@/main/pages';
import { cellNames, CellNamesObject, Column, convertToObjects, Row, Table } from '@/main/utils/table';
import { DropdownItem } from '@/main/store/@types/dropdown.d';
import { nabidkaTiskDialogUrl } from '@/modules/servis/paketovyModul/api';
import { FILTER } from '@/main/store/listEditTypes';
import { openEdit } from '@/main/router/routerPath';
import { PageMode } from '@/main/utils/pageMode';
import { NAME as ZAKAZKA_NAME, ZAKAZKA_DRUH_LOCALIZED } from '@/modules/servis/zakazka/constants';
import { provider as servisniPaketyProvider } from '@/modules/servis/zakazka/servisniPakety/api';
import { apiProvider as zakazkaProvider } from '@/modules/servis/zakazka/api';

import { ScreenSize } from '@/main/components/constants';

import DmsPdfDialog from '#components/DmsPdfDialog.vue';

import { store } from './store/list';
import { NAME } from './constants';
import { listMutations } from './store/types';

type TiskFilter = {
	VozidloId: number | null,
	StrednaklOzn: number | null,
	ProvozovnaId: number | null,
	FaktprofilId: number | null,
	LakdruhId: number | null,
	SkladOzn: number | null,
	PracovnikId: number | null,
	ReportType: string | null,
	CapaketdotazId: number | null,
	PaketId: number[],
};

export default listFactory(NAME, store).extend({
	components: {
		VozidloSelect: Vozidlo.components.Select,
		TypSelect: Typ.components.Select,
		LakDruhSelect: LakDruh.components.Select,
		PartnerSelect: Partner.components.Select,
		PracovnikSelect: Pracovnik.components.Select,
		NakladoveStrediskoSelect: NakladoveStredisko.components.Select,
		DmsPdfDialog,
	},
	computed: {
		getScreenSize() {
			return ScreenSize.MEDIUM;
		},
		mutationsMappers(): Record<string, string> {
			return {
				vozidlo: `${this.storeUri}/${listMutations.PAKETOVY_MODUL_VOZIDLO_SELECT_MAPPER}`,
				typkod: `${this.storeUri}/${listMutations.PAKETOVY_MODUL_TYP_KOD_SELECT_MAPPER}`,
				lakDruh: `${this.storeUri}/${listMutations.PAKETOVY_MODUL_LAK_DRUH_SELECT_MAPPER}`,
				zakaznik: `${this.storeUri}/${listMutations.PAKETOVY_MODUL_ZAKAZNIK_SELECT_MAPPER}`,
				pracovnik: `${this.storeUri}/${listMutations.PAKETOVY_MODUL_PRACOVNIK_SELECT_MAPPER}`,
				nakladoveStredisko: `${this.storeUri}/${listMutations.PAKETOVY_MODUL_NAKLADOVE_STREDISKO_SELECT_MAPPER}`,
			};
		},
		typkodFilter(): Record<string, any> {
			return {
				VyrobekvozOzn: this.VyrobekvozOzn,
				Typkod: this.Typkod,
			};
		},
		lakdruhFilter(): Record<string, any> {
			return {
				VyrobekvozOzn: this.VyrobekvozOzn,
				VyrazenPrp: false,
			};
		},
		tableCmp(): Table {
			const rowFilter = (row: Row) => {
				let result = true;
				if (this.SnNr !== null && this.SnNr.length > 0) result = _.startsWith(row.cells[this.cellNamesCmp.SN_NR], this.SnNr);
				if (result && this.MaPrp !== null) result = this.MaPrp === row.cells[this.cellNamesCmp.MA_PRP];
				if (result && this.CapaketVyberPrp !== null) result = this.CapaketVyberPrp === (row.cells[this.cellNamesCmp.SN_NR] !== null);
				if (result && this.EkonomyPrp !== null) result = Number(this.EkonomyPrp).toString() === row.cells[this.cellNamesCmp.ECONOMY_PRP_ZKT];
				if (result && this.CacelekNrs.length > 0) result = _.includes(this.CacelekNrs, Number(row.cells[this.cellNamesCmp.CACELEK_NR]));
				return result;
			};

			return new Table({
				...this.table,
				rows: _.map(_.filter(this.table.rows, rowFilter), (row: Row) => {
					const result = _.cloneDeep(row);
					const economy = row.cells[this.cellNamesCmp.ECONOMY_PRP_ZKT];
					result.cells[this.cellNamesCmp.ECONOMY_PRP_ZKT] = economy !== null ? Boolean(Number(economy)) : null;
					return result;
				}),
				columns: _.map(this.table.columns, (col: Column) => {
					if (col.columnName === 'ECONOMY_PRP_ZKT') {
						return { ...col, valueType: 'Boolean' };
					}
					return col;
				}),
			});
		},
		groupCounts(): { [key: number]: number } {
			const accumulator: { [key: number]: number } = _.reduce(this.dropdownList.Cacelek,
				(acc, o: { Value: number }) => ({ ...acc, [o.Value]: 0 }), {});
			return _.reduce(this.table.rows, (acc: { [key: number]: number }, row: Row) => {
				const result = { ...acc };
				result[Number(row.cells[this.cellNamesCmp.CACELEK_NR])] += 1;
				return result;
			}, accumulator);
		},
		cacelekDropdownCmp(): DropdownItem[] {
			return _.map(this.dropdownList.Cacelek, (o: DropdownItem) => ({ ...o, Text: `${o.Text} (${this.groupCounts[o.Value] || 0})` }));
		},
		cellNamesCmp(): CellNamesObject {
			return cellNames(this.table);
		},
		necesaryFilterFieldsFilled(): boolean {
			return this.VozidloIdText !== null || (this.Typkod !== null && this.TypkodText !== null && (this.PalivoPzn !== null || this.MotorKod !== null));
		},
		povinnePolozkyMessageHtmlFormated(): string {
			return this.LocalizeChyboveHlasky('Povinne_polozkyCAP').replace(/(?:\r\n|\r|\n)/g, '<br />');
		},
		isFromZakazka(): boolean {
			return !!this.props.filter.ZakazkaId;
		},
		nabidkaTiskDialogFilter(): TiskFilter {
			return {
				VozidloId: this.VozidloId,
				StrednaklOzn: this.StrednaklOzn,
				ProvozovnaId: this.ProvozovnaId,
				FaktprofilId: this.FakturaceprofilId,
				LakdruhId: this.LakdruhId,
				SkladOzn: this.SkladOzn ? Number(this.SkladOzn) : null,
				PracovnikId: this.PracovnikId,
				ReportType: 'pdf',
				CapaketdotazId: this.MultipleSelection[0]?.cells[this.cellNamesCmp.CAPAKETDOTAZ_ID] ?? null,
				PaketId: _.map(this.MultipleSelection, `cells[${this.cellNamesCmp.CAPAKET_ID}]`),
			};
		},
		isTiskDisabled(): boolean {
			return this.MultipleSelection.length === 0;
		},
		tiskTootlipText(): string | null {
			return this.isTiskDisabled ? this.LocalizeChyboveHlasky('emptyTiskCAPaket') : null;
		},
		zalozeniZakazkyTootlipText(): string | null {
			if (!this.VozidloId) return this.LocalizeChyboveHlasky('Neexistvozidlovkart');
			if (!this.ZakaznikId) return this.LocalizeChyboveHlasky('Neexistzakaznikvkart');
			return null;
		},
		isZalozeniZakazkyDisabled(): boolean {
			return this.isFromZakazka || !this.VozidloId || !this.ZakaznikId;
		},
		zalozeniZakazkyDialogLabel(): string {
			return this.LocalizeFormular('dlgZakazka');
		},
		pridaniPaketuDto(): Record<string, any> {
			return {
				ZakazkaId: this.props.filter.ZakazkaId ?? null,
				CapaketIds: _.map(this.MultipleSelection, `cells[${this.cellNamesCmp.CAPAKET_ID}]`),
				Filter: {
					DrMatPc: this.DrMatPc,
					DrMatSzb: this.DrMatSzb,
					FakturaceprofilId: this.FakturaceprofilId,
					KaroserieNr: this.KaroserieNr,
					KmStav: this.KmStav,
					LakdruhId: this.LakdruhId,
					ModelRok: this.ModelRok,
					MotorKod: this.MotorKod,
					PalivoPzn: this.PalivoPzn,
					PracovnikId: this.PracovnikId,
					PracovnikIdText: this.PracovnikIdText,
					ProvozovnaId: this.ProvozovnaId,
					SkladOzn: this.SkladOzn,
					StrednaklOzn: this.StrednaklOzn,
					StrednaklOznText: this.StrednaklOznText,
					Typkod: this.Typkod,
					TypkodText: this.TypkodText,
					VyrobekvozOzn: this.VyrobekvozOzn,
					ZakaznikId: this.ZakaznikId,
					ZakaznikSk: this.ZakaznikSk,
				},
			};
		},
		zakazkaCreateParams(): Record<string, any> {
			return {
				KaroserieNr: this.KaroserieNr,
				ProvozovnaId: this.ProvozovnaId,
				Spz: this.VozidloSpz,
				VozidloId: this.VozidloId,
				VyrobekvozOzn: this.VyrobekvozOzn,
				ZakazkaDruh: this.zakazkaDruh,
				OtevrenePrp: true,
				ZakaznikId: this.ZakaznikId,
			};
		},
		vyberCmdLabel(): string {
			return `${this.Localize('cmdVyber')} (${this.MultipleSelection.length})`;
		},
	},
	watch: {
		ZakaznikSk(newVal, oldVal) {
			if (this.notFirstZskChange && newVal !== oldVal) {
				this[listMutations.PAKETOVY_MODUL_GET_FAKTURACNI_PROFIL_DROPDOWN]();
			} else {
				this.notFirstZskChange = true;
				if (this.isFromZakazka) {
					return;
				}
			}
			this[listMutations.PAKETOVY_MODUL_INIT_FAKTURACNI_PROFIL_ID]();
		},
	},
	data() {
		return {
			listLoadDefault: ListLoadBehavior.NO_LOAD,
			notFirstZskChange: false,
			rowHtmlContent: null as null | string,
			showNabidkaTiskDialog: false,
			nabidkaTiskDialogUrl,
			showZalozeniZakazkyDialog: false,
			zakazkaDruhy: { W: ZAKAZKA_DRUH_LOCALIZED.W },
			zakazkaDruh: 'W',
			screenSize: ScreenSize.MEDIUM,
		};
	},
	methods: {
		handleMultipleSelection(data: object[]) {
			this[listMutations.PAKETOVY_MODUL_SET_MULTIPLE_SELECTION]({ data });
		},
		filterClick() {
			if (this.necesaryFilterFieldsFilled) {
				this.tableData();
			} else {
				showAlert({
					message: this.povinnePolozkyMessageHtmlFormated,
					title: this.LocalizeChyboveHlasky('errorTitle'),
					options: {
						type: 'error',
						customClass: 'message-box--max-content-width message-box--top-aligned-icon',
						closeOnPressEscape: true,
						closeOnClickModal: true,
						dangerouslyUseHTMLString: true,
					},
				});
			}
		},
		onProvozovnaIdChange() {
			this[listMutations.PAKETOVY_MODUL_CHECK_STREDNAKL]();
		},
		handleExpandedRowUpdate(row: Row | null) {
			if (row !== null) {
				const rowObject = (convertToObjects({ rows: [row], columns: this.table.columns }))[0] as { MaPodminkyHtml: string };
				this.rowHtmlContent = rowObject.MaPodminkyHtml;
			} else {
				this.rowHtmlContent = null;
			}
		},
		async loadFilter() {
			const { data } = this.isFromZakazka ? await this.filterInit(this.props.filter)
				: await this.$store.dispatch(`${this.storeUri}/${FILTER}`, this.isSelectList);
			return data;
		},
		async onZalozitZakazkaDialogOkClicked() {
			this.showZalozeniZakazkyDialog = false;
			this.startLoading();
			try {
				const zakResp = await zakazkaProvider.default(this.zakazkaCreateParams);
				const createdResp = await zakazkaProvider.createEntity(zakResp.data);
				const id = createdResp.headers.location.split('=')[1];
				await servisniPaketyProvider.pridaniPaketuNaZakazku({ ...this.pridaniPaketuDto, ZakazkaId: id });
				await openEdit(ZAKAZKA_NAME, PageMode.EDIT, { id });
			} finally {
				this.endLoading();
			}
		},
		async onVyberClick() {
			try {
				this.startLoading();
				if (this.MultipleSelection.length > 0) {
					await servisniPaketyProvider.pridaniPaketuNaZakazku(this.pridaniPaketuDto);
					this.refreshPreviousPage = true;
				}
				this.closeClick();
			} finally {
				this.endLoading();
			}
		},
		updateVyrobekvozOzn() {
			this.paketovyModulTypKodSelectMapper({ data: { isClear: true, typkod: null, text: null } });
		},
	},
});
